export default __webpack_public_path__ + "static/media/kick_mid.03a75cf2.mp3";